import PreviousPeriodDataCard from 'components/data-card/variants/previous-period-data-card/previous-period-data-card.component';
import { useSearchQueryContext } from 'components/search/search.hooks';
import SummaryCardBoundary from 'components/summary-card-boundary/summary-card-boundary.component';
import { useTranslation } from 'react-i18next';

const queryName = 'brandSummaryCards';

const BrandSummaryCards = () => {
  const { t } = useTranslation();
  const { data } = useSearchQueryContext(queryName);

  const {
    totalMembers,
    activeMembers,
    activeMembersPercent,
    deletedAccounts,
    loyaltySales,
    loyaltyContributionPercentOfSales,
    loyaltyContributionPercentOfOrders,
    loyaltyAverageOrder,
    membersWhoOrdered,
    activityRateMembersWhoOrdered,
  } = data;

  return (
    <SummaryCardBoundary queryName={queryName} expectedCount={10}>
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.totalMembers.label')}
        value={totalMembers?.value}
        valueType={totalMembers?.cardType}
        previousPeriodPercent={totalMembers?.comparisonNumber}
      />
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.membersWhoOrdered.label')}
        value={membersWhoOrdered?.value}
        valueType={membersWhoOrdered?.cardType}
        previousPeriodPercent={membersWhoOrdered?.comparisonNumber}
      />
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.activeMembers.label')}
        value={activeMembers?.value}
        valueType={activeMembers?.cardType}
        previousPeriodPercent={activeMembers?.comparisonNumber}
      />
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.activityRateAllMembers.label')}
        value={activeMembersPercent?.value}
        valueType={activeMembersPercent?.cardType}
        previousPeriodPercent={activeMembersPercent?.comparisonNumber}
      />
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.activeMemberPercent.label')}
        value={activityRateMembersWhoOrdered?.value}
        valueType={activityRateMembersWhoOrdered?.cardType}
        previousPeriodPercent={activityRateMembersWhoOrdered?.comparisonNumber}
      />
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.deletedAccounts.label')}
        value={deletedAccounts?.value}
        valueType={deletedAccounts?.cardType}
        previousPeriodPercent={deletedAccounts?.comparisonNumber}
        PreviousPeriodDataCardDescriptionProps={{
          invertColor: true,
        }}
      />
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.loyaltyOrdersNetSales.label')}
        value={loyaltySales?.value}
        valueType={loyaltySales?.cardType}
        previousPeriodPercent={loyaltySales?.comparisonNumber}
      />
      <PreviousPeriodDataCard
        title={t(
          'page.loyaltyPerformanceReport.loyaltyContributionPercentOfSales.label',
        )}
        value={loyaltyContributionPercentOfSales?.value}
        valueType={loyaltyContributionPercentOfSales?.cardType}
        previousPeriodPercent={
          loyaltyContributionPercentOfSales?.comparisonNumber
        }
      />
      <PreviousPeriodDataCard
        title={t(
          'page.loyaltyPerformanceReport.loyaltyContributionPercentOfOrders.label',
        )}
        value={loyaltyContributionPercentOfOrders?.value}
        valueType={loyaltyContributionPercentOfOrders?.cardType}
        previousPeriodPercent={
          loyaltyContributionPercentOfOrders?.comparisonNumber
        }
      />
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.loyaltyAverageCheck.label')}
        value={loyaltyAverageOrder?.value}
        valueType={loyaltyAverageOrder?.cardType}
        previousPeriodPercent={loyaltyAverageOrder?.comparisonNumber}
      />
    </SummaryCardBoundary>
  );
};

export default BrandSummaryCards;
